import { render } from "./TopMobileMenuBar.vue?vue&type=template&id=56f0dec2&scoped=true"
import script from "./TopMobileMenuBar.vue?vue&type=script&lang=js"
export * from "./TopMobileMenuBar.vue?vue&type=script&lang=js"

import "./TopMobileMenuBar.vue?vue&type=style&index=0&id=56f0dec2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f0dec2"]])

export default __exports__